// extracted by mini-css-extract-plugin
module.exports = {"connected":"ConnectedButton_connected__WYjJu","balance":"ConnectedButton_balance__1MFMh"};